import campaignsQueries from './campaigns'

export default {
    ...campaignsQueries
}